/** A stored name's first word, "Nora" for "Nora Peeters". Empty when there is no name. */
export function firstName(name: string | null | undefined): string {
  return name?.trim().split(/\s+/)[0] ?? '';
}
